import script from "./HeaderTypeA.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderTypeA.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderTypeA.vue?vue&type=style&index=0&id=6647aaf1&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6647aaf1"]])

export default __exports__